import React from 'react'
import { withRouter } from "react-router-dom";
// import TableComponent, { TableOp } from '../table/TableOps';
import { Dialog, DialogContentText, DialogTitle, DialogActions, DialogContent, Button } from '@material-ui/core';
import Http from '../../../Http';
import TableComponent, { TableOp } from '../../../components/table/TableOps';
import Entregada from './Entregada';
import ACCESS from '../../../ACCESS';
// import Embarcar from './Embarcar';
// import Http from '../../Http';

class Documentadas extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'guia/documentadas', deleteUrl: 'sucursal/delete', deleteField: 'sucursal_nombre', modUrl: '/Catalogo/Guia' },
      TableOp.Table('Guías en ruta', [
        { label: 'Folio', id: 'g_folio' },
        { label: 'Fecha', id: 'g_fecha' },
      ], [
        // { id: 'embarcar', icon: 'assignment' },
        { id: 'entregada', icon: 'assignment', tooltip: 'No entregada', access: [ACCESS.MARCAR_ENTREGAS.MARCAR_GUIA_COMO_NO_ENTREGADA] },
        // { id: 'historial', icon: 'history' },
      ]))
    this.table();
  }

  action = (id, row) => {
    console.log(id, row)
    if (id === 'cancel') {
      this.setState({ dRow: row, dOpen: true })
    }
    else if (id === 'historial') {
      this.setState({ dRow: row, dlOpen: true })
    }
    else if (id === 'entregada') {
      this.setState({ dRow: row, deOpen: true })
    }
    else if (id === 'embarcar') {
      this.setState({ dRow: row, demOpen: true })
    }
  }

  entregada = async (op) => {
    // if (op) {
    //   try {
    //     let Res = await Http.post(`guia/${this.state.dRow.id}/entregar`, { g_fecha_entrega: new Date() });
    //     console.log(Res)
    //     if (!Res.error) {
    //       this.table();
    //       this.setState({ deOpen: false })
    //     }
    //   } catch (error) {
    //     this.setState({ deOpen: false })
    //   }
    //   return;
    // }
    this.table();
    this.setState({ deOpen: false });
  }

  embarcada = async (op) => {
    if (op) {
      try {
        let Res = await Http.post(`guia/${this.state.dRow.id}/embarcar`, {});
        if (!Res.error) {
          this.table();
          this.setState({ demOpen: false })
        }
      } catch (error) {
        this.setState({ demOpen: false })
      }
      return;
    }
    this.setState({ demOpen: false });
  }

  render() {
    const { dRow = {}, deOpen, demOpen } = this.state;
    return (
      <div>
        <div style={{ padding: 20 }}>
          <this.TableRender />
        </div>

        <div>
          <Dialog
            open={deOpen ? deOpen : false}
            onClose={() => this.setState({ deOpen: false })}
          >
            {/* <DialogTitle>Confirmar entrega</DialogTitle> */}
            <DialogContent>
              <Entregada guiaId={dRow.id} onSave={() => this.entregada()} />
              {/* <DialogContentText>
                Se va a marcar como <span style={{ fontWeight: 'bold' }}>entregada</span> la guía #{dRow ? dRow.g_folio : ''}
              </DialogContentText> */}
            </DialogContent>
            {/* <DialogActions>
              <Button onClick={() => this.entregada(false)} color="primary">
                No
              </Button>
              <Button onClick={() => this.entregada(true)} color="primary" autoFocus>
                Sí
              </Button>
            </DialogActions> */}
          </Dialog>
        </div>

        <div>
          <Dialog
            open={demOpen ? demOpen : false}
            onClose={() => this.setState({ demOpen: false })}
          >
            <DialogTitle>Embarcar guía</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Se va a marcar como <span style={{ fontWeight: 'bold' }}>embarcada</span> la guía #{dRow ? dRow.g_folio : ''}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.embarcada(false)} color="primary">
                No
              </Button>
              <Button onClick={() => this.embarcada(true)} color="primary" autoFocus>
                Sí
            </Button>
            </DialogActions>
          </Dialog>
        </div>

        {/* <div>
          <Dialog
            open={dembOpen ? dembOpen : false}
            onClose={() => this.setState({ dembOpen: false })}
          >
            <DialogContent>
              <Embarcar id={dRow ? dRow.id : ''} />
            </DialogContent>
          </Dialog>
        </div> */}

      </div>
    )
  }
}

export default withRouter(Documentadas)